import React from 'react';
import { CryptoCurrencyMarket } from 'react-ts-tradingview-widgets';
import { MiniChart } from 'react-ts-tradingview-widgets';

import useWindowSize from 'utils/windowSIze';

export const CryptoChart = () => {
  const { width } = useWindowSize();

  return (
    <div className="overflow-auto pb-3">
      <CryptoCurrencyMarket
        height={300}
        width={width < 400 ? 350 : 950}
      ></CryptoCurrencyMarket>
    </div>
  );
};

export const MiniChartWidget = () => {
  return <MiniChart width="100%" />;
};
